import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListingSection from '@stencil/dstories/src/components/CityCountryPage/ListingSection/listing-section';
import DetailsSection from '@stencil/dstories/src/components/CityCountryPage/DetailsSection/details-section';
import { updateSelectedDestination } from '@stencil/flights-seo-reducers/src/SRP/redux/actions';
import Map from '@stencil/dstories/src/components/CityCountryPage/RightPane/map';
import {
  sortFlightsSelector,
  constructThorUrlForCityCountry,
  isStoreEmptySelector,
  hasPrefetchedChunksSelector,
  cityCountryBookingReviewDataSelector,
  experimentMetaDataSelector,
  selectedFlightSelector,
  filteredAndSortedDisplayDetailsFlights,
  departureSelector,
  tripDurationSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import {
  sortFlights,
  updateSelectedFlight,
  updateDeparture,
  updateArrival
} from '@stencil/flights-seo-reducers/src/SRP/redux/actions';
import addDays from '@stencil/date-utils/src/addDays';
import chunkedResponseUsingIframe from '@stencil/chunked-response-using-iframe';
import { parseData } from '@stencil/flights-seo-reducers/src/SRP/redux/thunks';
import goToReviewPage from '@stencil/flights-utils/src/go-to-review-page';
import { getABResponse } from '@stencil/flights-utils/src/flights-utils';

const SeoCityCountryRight = ({
  airportInfo,
  selectedDestination,
  h1header,
  flavour,
  travelType,
  source,
  destinations,
  journeyType,
  cityRef,
  countryRef,
  continentRef,
  isFilterApplied,
  showDtlSection,
  sortSettings,
  handleOpenDtlSection,
  handleCloseDtlSection,
  handleFlightSelection,
  calendarDateChanged,
  // fetchFareCalendareData,
  applySortSettings,
  countryTravelGuidelines,
  handleResetFilters,
  isSEO,
  seoData,
  // details of destinations
  getFareData,
  fareCalendarData,
  isVisibleCalendar,
  setVisibleCalendar
}) => {
  const dispatch = useDispatch();
  const sortFlightsSettings = useSelector(sortFlightsSelector);
  const thorUrl = useSelector(constructThorUrlForCityCountry);
  const isStoreEmpty = useSelector(isStoreEmptySelector);
  const hasPrefetchedChunks = useSelector(hasPrefetchedChunksSelector);
  const filteredAndSortedDetailsFlights = useSelector(filteredAndSortedDisplayDetailsFlights);
  const experimentMetaData = useSelector(experimentMetaDataSelector);
  const selectedFlight = useSelector(selectedFlightSelector);
  const departure = useSelector(departureSelector);
  const tripDuration = useSelector(tripDurationSelector);
  const bookingReviewData = useSelector(cityCountryBookingReviewDataSelector);
  const pokusResponse = getABResponse();

  const [numberOfDestinations, setNumberOfDestinations] = useState(10);
  const [detailsFlights, setDetailsFlights] = useState(null);
  const [destinationsForMap, setDestinationsForMap] = useState(destinations);

  useEffect(() => {
    if (destinations) {
      setDestinationsForMap(destinations?.slice(0, 10));
    }
  }, destinations);

  useEffect(() => {
    setDetailsFlights(filteredAndSortedDetailsFlights);
  }, [filteredAndSortedDetailsFlights]);

  useEffect(() => {
    if (!selectedDestination.toCity && !thorUrl) {
      return;
    }
    setDetailsFlights(null);
    chunkedResponseUsingIframe('sData', thorUrl, dispatch, parseData, true, 'srp');
  }, [thorUrl, isStoreEmpty, hasPrefetchedChunks]);

  useEffect(() => {
    const { bookData = {} } = bookingReviewData || {};
    const { o = undefined } = bookData ? bookData : {};
    if (o && o.length > 0) {
      const isMSE = o.length > 1;
      // const isBundle = o[0].al ? true : false;
      if (!isMSE) {
        // setShowDisableOverlay(true);
        goToReviewPage(
          flavour,
          bookingReviewData,
          travelType,
          experimentMetaData,
          true,
          handleHulkResponse,
          selectedFlight,
          false,
          false,
          null,
          '',
          pokusResponse?.metadataValues?.web_gi_unification
        );
      }
    }
  }, [bookingReviewData]);

  const handleHulkResponse = () => {
    // setShowDisableOverlay(false);
    dispatch(updateSelectedFlight({}));
  };

  const handleSelectedDestination = destination => {
    dispatch(updateSelectedDestination(destination));

    if (Object.keys(destination).length === 0) {
      handleCloseDtlSection();
      return;
    }

    const tempDate = destination['minCostStop'].depDate.split(' ')[0];
    const year = tempDate.split('-')[0];
    const month = tempDate.split('-')[1] - 1;
    const date = tempDate.split('-')[2];
    const departureDate = new Date(year, month, date);

    dispatch(updateDeparture(departureDate));

    if (tripDuration && journeyType == 'rt') {
      const arrivalDate = addDays(departureDate, tripDuration);
      dispatch(updateArrival(arrivalDate));
    }
    dispatch(sortFlights({ currentSort: 'cheapest', isAscending: true }));
  };

  const applySortFlightsSettings = (sortType, isAscending = true) => {
    dispatch(sortFlights({ currentSort: sortType, isAscending: isAscending }));
  };

  const addSelectedDestinationMarkerToMap = index => {
    if (index >= 10 && destinationsForMap) {
      setDestinationsForMap([...destinationsForMap?.slice(0, 10), destinations[index]]);
    }
    handleOpenDtlSection(index);
  };

  return (
    <>
      <Map
        destinations={destinationsForMap}
        cityRef={cityRef}
        source={airportInfo?.from || {}}
        handleSelectedDestination={handleSelectedDestination}
        selectedDestination={selectedDestination}
        handleOpenDtlSection={handleOpenDtlSection}
        setNumberOfDestinations={setNumberOfDestinations}
        numberOfDestinations={numberOfDestinations}
      />
      {selectedDestination && selectedDestination.toCity ? (
        <DetailsSection
          showDtlSection={showDtlSection}
          handleCloseDtlSection={handleCloseDtlSection}
          destination={selectedDestination}
          // searchWidgetData={searchWidgetData}
          // handleDateSelection={handleDateSelection}
          handleFlightSelection={handleFlightSelection}
          applySortFlightsSettings={applySortFlightsSettings}
          sortFlightsSettings={sortFlightsSettings}
          departure={departure}
          getFareData={getFareData}
          calendarDateChanged={calendarDateChanged}
          fareCalendarData={fareCalendarData}
          detailsDestinations={detailsFlights}
          cityRef={cityRef}
          countryRef={countryRef}
          continentRef={continentRef}
          countryTravelGuidelines={countryTravelGuidelines}
          isVisibleCalendar={isVisibleCalendar}
          setVisibleCalendar={setVisibleCalendar}
          queryParam={bookingReviewData?.queryParam}
        />
      ) : null}
      <ListingSection
        h1header={h1header}
        source={source}
        destinations={destinations}
        cityRef={cityRef}
        countryRef={countryRef}
        continentRef={continentRef}
        showDtlSection={showDtlSection}
        sortSettings={sortSettings}
        isFilterApplied={isFilterApplied}
        numberOfDestinations={numberOfDestinations}
        setNumberOfDestinations={setNumberOfDestinations}
        handleOpenDtlSection={addSelectedDestinationMarkerToMap}
        handleSelectedDestination={handleSelectedDestination}
        applySortSettings={applySortSettings}
        handleResetFilters={handleResetFilters}
        seoData={seoData}
        isSEO={isSEO}
      />
    </>
  );
};
export default SeoCityCountryRight;
